export function matchesShowWhenValue(
  value: unknown,
  expectedValue: string,
): boolean {
  if (
    typeof value !== "string" &&
    typeof value !== "number" &&
    typeof value !== "boolean"
  ) {
    return false;
  }
  return String(value) === expectedValue;
}

export function isFieldShown(
  showWhen: Record<string, string> | undefined,
  values: Record<string, unknown>,
): boolean {
  if (!showWhen) return true;
  return Object.entries(showWhen).every(([controller, expected]) =>
    matchesShowWhenValue(values[controller], expected),
  );
}
